module.exports = __webpack_public_path__ + "img/stateyellow_bg.d378de02.png";